import type { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import { useSecondaryBack } from "./use-secondary-back";

/** Title row for More/Settings screens: back arrow inline with the title, actions on the right.
 *  `onBack` overrides the menu-level context when a screen has its own drill-down (e.g. Prices group). */
export default function SecondaryHeading({
  title,
  icon,
  children,
  onBack: onBackProp,
}: {
  title: string;
  icon?: ReactNode;
  children?: ReactNode;
  onBack?: () => void;
}) {
  const contextBack = useSecondaryBack();
  const onBack = onBackProp ?? contextBack;
  return (
    <div className="section-heading settings-save-bar secondary-heading">
      <div className="secondary-heading-title">
        {onBack && (
          <button type="button" className="secondary-back" aria-label="Back" onClick={onBack}>
            <ArrowLeft size={16} strokeWidth={2.25} />
          </button>
        )}
        {icon && <span className="secondary-heading-icon" aria-hidden="true">{icon}</span>}
        <h2>{title}</h2>
      </div>
      {children}
    </div>
  );
}
